export default {
      id: "menu__shipment_fill-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.svg#menu__shipment_fill",
      toString: function () {
        return this.url;
      }
    }